import { useTheme } from '@mui/material/styles'
import { useEffect, useState } from 'react'
import ReactApexcharts from 'react-apexcharts'
import { formatNumber } from '../../../common/commonFunctions'



interface Cptys {
  values: any[]
  legends: any[]
}

const LemurDashboardCCByCPTY = (props: Cptys) => {
  const [height, setHeight] = useState<string>('250')
  const { legends, values } = props
  const series = values
  const theme = useTheme()

  const truncatedLabels = [...legends].map(lbl => {
    if (lbl.length > 17) {
      return lbl.substr(0, 15 - 1) + '…'
    }

    return lbl
  })

  const options = {
    theme: {
      mode: theme.palette.mode
    },
    series: series,
    chart: {
      width: 380
    },
    labels: truncatedLabels,
    legend: {
      tooltipHoverFormatter: (seriesName: any, opts: any) => {
        const idx = opts?.seriesIndex

        return [...legends][idx]
      }
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }
    ],
    colors: [
      '#4635A6',
      '#7EAFD8',
      '#C063B1',
      '#1A9545',
      '#EADB97',
      '#5791FF',
      '#FF6A81',
      '#6C8996',
      '#BD38EB',
      '#5DD0DD'
    ],
    tooltip: {
      x: {
        show: false
      },
      y: {
        formatter: function (value: any) {
          return formatNumber.format(parseInt(value))
        }
      }
    }
  }

  useEffect(() => {
    if (window.innerWidth >= 3072) {
      setHeight('auto')
    } else if (window.innerWidth >= 2560) {
      setHeight('auto')
    } else if (window.innerWidth >= 1920) {
      setHeight('auto')
    }
  }, [])

  useEffect(() => {
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 3072) {
        setHeight('auto')
      } else if (window.innerWidth >= 2560) {
        setHeight('auto')
      } else if (window.innerWidth >= 1920) {
        setHeight('auto')
      }
    })
  })

  return <ReactApexcharts type='pie' height={height} options={options} series={series} />
}

export default LemurDashboardCCByCPTY
